import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { useIsMobile } from "@/hooks/useResponsive";

export const ProfileDetailSkeleton = () => {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ maxWidth: 1040, mx: "auto", p: isMobile ? 1 : 2 }}>
      {/* Breadcrumbs */}
      <Skeleton variant="text" width={200} height={24} sx={{ mb: 1 }} />
      {/* Header row */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Skeleton variant="text" width={120} height={32} />
        <Skeleton variant="text" width={180} height={20} />
      </Box>
      {/* Profile info section */}
      <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? 2 : 3, mb: 3 }}>
        <Skeleton
          variant="rounded"
          width={isMobile ? "100%" : 200}
          height={isMobile ? 180 : 200}
          sx={{ flexShrink: 0 }}
        />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="40%" height={36} sx={{ mb: 2 }} />
          <Skeleton variant="text" width="60%" height={28} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="55%" height={28} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="50%" height={28} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="45%" height={28} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="35%" height={28} />
        </Box>
      </Box>
      {/* Editor area */}
      <Skeleton variant="rounded" width="100%" height={isMobile ? 200 : 300} />
    </Box>
  );
};
